export const setupOnboarding = {
  piezas: {
    confirmacion: { etiqueta: "التأكيد", larga: "تأكيد الحجز", porque: "يجري استخدام الإعداد العام لحسابك، وليس إعدادًا خاصًا بهذا السكن." },
    bienvenida: { etiqueta: "الترحيب", larga: "رسالة الترحيب", porque: "تُرسل الآن رسالة الترحيب الافتراضية، وهي ليست رسالتك." },
    checkin: { etiqueta: "تسجيل الوصول", larga: "إرسال تسجيل الوصول", porque: "يُرسل الآن في الوقت الافتراضي، وقد لا يناسبك." },
    horas: { etiqueta: "المواعيد", larga: "وقت الوصول والمغادرة", porque: "بدون مواعيدك، يُجاب الضيف بالمواعيد الافتراضية عندما يسأل." },
    cerradura: { etiqueta: "الدخول", larga: "القفل والدخول", porque: "يصل الضيف إلى الباب ولا يعرف كيف يفتح." },
    servicios: { etiqueta: "الخدمات", larga: "خدمات السكن", porque: "لا محرك الحجز ولا الوكيل يعرف ما الذي تقدّمه." },
    politicas: { etiqueta: "القواعد", larga: "السياسات والقواعد", porque: "يوافق الضيف على قواعد افتراضية، وليست قواعدك." },
  },
  titular: {
    listo: "كل شيء جاهز",
    unoAMedias: "سكنك مُعدّ إلى النصف",
    variosAMedias: "أماكن إقامتك مُعدّة إلى النصف",
    casi: "بقي القليل لتنتهي",
  },
  consecuencia: {
    bienvenida: "في هذه الأثناء يتلقى ضيوفك رسالة الترحيب الافتراضية، وهي ليست رسالتك.",
    cerradura: "في هذه الأثناء هناك ضيوف سيصلون إلى الباب دون معرفة كيفية الفتح.",
    politicas: "في هذه الأثناء يوافق ضيوفك على قواعد افتراضية، وليست قواعدك.",
    generico: "في هذه الأثناء تُستخدم الإعدادات الافتراضية، وليست إعداداتك.",
  },
  explicacion: {
    listoUno: "يستطيع سكنك الآن استقبال الضيوف.",
    listoVarios: "تستطيع أماكن إقامتك الـ {n} الآن استقبال الضيوف.",
    ajustesFinos: "الإعدادات الدقيقة — الأسعار والقنوات والتجارب — بانتظارك في كل إعلان متى شئت.",
    faltaUno: "بقي سكن واحد لإتمامه.",
    faltanVarios: "بقي {n} أماكن إقامة لإتمامها.",
  },
  resumen: {
    unAlojamiento: "سكن واحد",
    nAlojamientos: "{n} أماكن إقامة",
    unoPorPreparar: "واحد قيد التحضير",
    nPorPreparar: "{n} قيد التحضير",
    listos: "{listos} جاهزة",
  },
  anillo: {
    rotulo: "مُعدّ",
    ariaCorta: "‏{n}% مُعدّ",
    ariaLarga: "‏{n}% من الإعداد مكتمل",
  },
  cifras: {
    listos: "جاهزة ·",
    ajustes: "إعدادات منجزة",
    ariaAjustes: "{hechas} من {total} إعدادات منجزة",
    marcador: "{hechas} من {total}",
  },
  ventana: {
    titulo: "إغلاق هذا التنبيه؟",
    texto: "لن يظهر بعد الآن في اللوحة، حتى لو بقي شيء لإعداده.",
    notaAntes: "يمكنك استعادته وقتما تشاء من",
    notaRuta: "تخصيص ← إظهار تنبيه الإعداد",
    cancelar: "إلغاء",
    ocultar: "إغلاق",
  },
  acciones: {
    verQueFalta: "انظر ما الناقص",
    buscar: "ابحث عن سكن",
    sinResultados: "لا يوجد سكن معلّق بهذا الاسم.",
    verClaro: "العرض الفاتح",
    verOscuro: "العرض الداكن",
    ampliar: "توسيع",
    ampliarAria: "توسيع التنبيه",
    minimizar: "تصغير",
    minimizarAria: "تصغير التنبيه",
    entendido: "فهمت",
    entendidoAria: "فهمت، أغلق التنبيه",
    ocultar: "إغلاق",
    ocultarAria: "إغلاق تنبيه الإعداد",
    empezar: "ابدأ",
    continuar: "متابعة",
    hecho: "تم",
    teToca: "دورك:",
    unidades: "{n} وحدات",
  },
};
